// One place for the names shown across the portal, so every screen and
// browser tab says the same thing.
export const BANK_NAME = "Asokore Community Bank PLC";
export const SUITE_NAME = "CBX Suite";
export const SUITE_TAGLINE = "Core Banking eXperience";
export const VENDOR_NAME = "RosoftSavvy";

// The bank's colours for the Systems page banner, taken from its logo.
// logoFit: "cover" for a round emblem, "contain" to show the logo whole.
export const BRAND_THEME = {
  from: "#0a3d1c",
  to: "#1f9d46",
  stripe1: "#f4b23e",
  stripe2: "#ffffff",
  logoFit: "cover",
};

export const pageTitle = (page) =>
  page ? `${page} | ${SUITE_NAME}` : SUITE_NAME;

// Sign the user out after this long with no mouse or keyboard use in the
// portal, warning them a little before.
export const IDLE_LIMIT_MS = 15 * 60 * 1000;
export const IDLE_WARNING_MS = 60 * 1000;

// Set when the idle timer signs someone out, so the login page can say why
export const IDLE_SIGNED_OUT_KEY = "cbx_idle_signed_out";
